import React from "react";

const CreatePassword = ({
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  passwordVisibility,
  togglePasswordVisibility,
  passwordValidationClicked,
  passwordError,
  setPasswordError,
  validationErrors,
}) => {
  return (
    <>
      <fieldset className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-10">
        <legend className="sr-only">Password Input</legend>
        <label
          htmlFor="password"
          className="text-[#1d2639] text-base font-normal font-['Lato']"
        >
          Password
        </label>
        <div className="relative w-full">
          <input
            type={passwordVisibility.newPassword ? "text" : "password"}
            placeholder="Password"
            value={newPassword}
            className={`w-full h-12 p-3 pr-10 bg-[#f8f8f8] rounded-lg border-2 ${
              passwordValidationClicked && newPassword.length < 8
                ? "border-solid border-2 border-red-500"
                : ""
            }`}
            onChange={(e) => {
              setNewPassword(e.target.value);
              if (passwordError) setPasswordError("");
            }}
          />
          <button
            type="button"
            onClick={() => togglePasswordVisibility("newPassword")}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path
                d="M7.99984 6.5C7.4694 6.5 6.9607 6.71071 6.58562 7.08579C6.21055 7.46086 5.99984 7.96957 5.99984 8.5C5.99984 9.03043 6.21055 9.53914 6.58562 9.91421C6.9607 10.2893 7.4694 10.5 7.99984 10.5C8.53027 10.5 9.03898 10.2893 9.41405 9.91421C9.78912 9.53914 9.99984 9.03043 9.99984 8.5C9.99984 7.96957 9.78912 7.46086 9.41405 7.08579C9.03898 6.71071 8.53027 6.5 7.99984 6.5ZM7.99984 11.8333C7.11578 11.8333 6.26794 11.4821 5.64281 10.857C5.01769 10.2319 4.6665 9.38406 4.6665 8.5C4.6665 7.61595 5.01769 6.7681 5.64281 6.14298C6.26794 5.51786 7.11578 5.16667 7.99984 5.16667C8.88389 5.16667 9.73174 5.51786 10.3569 6.14298C10.982 6.7681 11.3332 7.61595 11.3332 8.5C11.3332 9.38406 10.982 10.2319 10.3569 10.857C9.73174 11.4821 8.88389 11.8333 7.99984 11.8333ZM7.99984 3.5C4.6665 3.5 1.81984 5.57333 0.666504 8.5C1.81984 11.4267 4.6665 13.5 7.99984 13.5C11.3332 13.5 14.1798 11.4267 15.3332 8.5C14.1798 5.57333 11.3332 3.5 7.99984 3.5Z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>
      </fieldset>

      <fieldset className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-2">
        <legend className="sr-only">Confirm Password Input</legend>
        <label
          htmlFor="confirmPassword"
          className="text-[#1d2639] text-base font-normal font-['Lato']"
        >
          Confirm Password
        </label>
        <div className="relative w-full">
          <input
            type={passwordVisibility.confirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
            value={confirmPassword}
            className={`w-full h-12 p-3 pr-10 bg-[#f8f8f8] rounded-lg border-2 ${
              passwordValidationClicked && confirmPassword !== newPassword
                ? "border-solid border-2 border-red-500"
                : ""
            }`}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              if (passwordError) setPasswordError("");
            }}
          />
          <button
            type="button"
            onClick={() => togglePasswordVisibility("confirmPassword")}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path
                d="M7.99984 6.5C7.4694 6.5 6.9607 6.71071 6.58562 7.08579C6.21055 7.46086 5.99984 7.96957 5.99984 8.5C5.99984 9.03043 6.21055 9.53914 6.58562 9.91421C6.9607 10.2893 7.4694 10.5 7.99984 10.5C8.53027 10.5 9.03898 10.2893 9.41405 9.91421C9.78912 9.53914 9.99984 9.03043 9.99984 8.5C9.99984 7.96957 9.78912 7.46086 9.41405 7.08579C9.03898 6.71071 8.53027 6.5 7.99984 6.5ZM7.99984 11.8333C7.11578 11.8333 6.26794 11.4821 5.64281 10.857C5.01769 10.2319 4.6665 9.38406 4.6665 8.5C4.6665 7.61595 5.01769 6.7681 5.64281 6.14298C6.26794 5.51786 7.11578 5.16667 7.99984 5.16667C8.88389 5.16667 9.73174 5.51786 10.3569 6.14298C10.982 6.7681 11.3332 7.61595 11.3332 8.5C11.3332 9.38406 10.982 10.2319 10.3569 10.857C9.73174 11.4821 8.88389 11.8333 7.99984 11.8333ZM7.99984 3.5C4.6665 3.5 1.81984 5.57333 0.666504 8.5C1.81984 11.4267 4.6665 13.5 7.99984 13.5C11.3332 13.5 14.1798 11.4267 15.3332 8.5C14.1798 5.57333 11.3332 3.5 7.99984 3.5Z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>
      </fieldset>
      <div className="flex flex-col gap-8">
        <ul className="grid grid-cols-2 sm:grid-cols-3 sm:gap-x-4 w-full text-[11px] mt-2">
          <li
            className={`flex items-center ${
              newPassword && newPassword.length < 8
                ? "text-red-500"
                : newPassword && newPassword.length >= 8
                ? "text-blue-500"
                : "text-gray-500"
            }`}
          >
            {newPassword && newPassword.length >= 8 ? (
              <svg
                className="text-blue-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            ) : newPassword && newPassword.length < 8 ? (
              <svg
                className="text-red-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="8"
                viewBox="0 0 7 8"
                fill="none"
              >
                <path
                  d="M7 1.205L6.295 0.5L3.5 3.295L0.705 0.5L0 1.205L2.795 4L0 6.795L0.705 7.5L3.5 4.705L6.295 7.5L7 6.795L4.205 4L7 1.205Z"
                  fill="#EB1004"
                />
              </svg>
            ) : (
              <svg
                className="text-gray-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            )}
            8 characters or Longer
          </li>

          <li
            className={`flex items-center ${
              newPassword && /[A-Z]/.test(newPassword)
                ? "text-blue-500"
                : newPassword && !/[A-Z]/.test(newPassword)
                ? "text-red-500"
                : "text-gray-500"
            }`}
          >
            {newPassword && /[A-Z]/.test(newPassword) ? (
              <svg
                className="text-blue-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            ) : newPassword && !/[A-Z]/.test(newPassword) ? (
              <svg
                className="text-red-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="8"
                viewBox="0 0 7 8"
                fill="none"
              >
                <path
                  d="M7 1.205L6.295 0.5L3.5 3.295L0.705 0.5L0 1.205L2.795 4L0 6.795L0.705 7.5L3.5 4.705L6.295 7.5L7 6.795L4.205 4L7 1.205Z"
                  fill="#EB1004"
                />
              </svg>
            ) : (
              <svg
                className="text-gray-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            )}
            At Least one uppercase letter
          </li>

          <li
            className={`flex items-center ${
              newPassword && /\d/.test(newPassword)
                ? "text-blue-500"
                : newPassword && !/\d/.test(newPassword)
                ? "text-red-500"
                : "text-gray-500"
            }`}
          >
            {newPassword && /\d/.test(newPassword) ? (
              <svg
                className="text-blue-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            ) : newPassword && !/\d/.test(newPassword) ? (
              <svg
                className="text-red-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="8"
                viewBox="0 0 7 8"
                fill="none"
              >
                <path
                  d="M7 1.205L6.295 0.5L3.5 3.295L0.705 0.5L0 1.205L2.795 4L0 6.795L0.705 7.5L3.5 4.705L6.295 7.5L7 6.795L4.205 4L7 1.205Z"
                  fill="#EB1004"
                />
              </svg>
            ) : (
              <svg
                className="text-gray-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            )}
            At least one number
          </li>

          <li
            className={`flex items-center ${
              newPassword && /[!@#$%^&*(),.?":{}|<>]/.test(newPassword)
                ? "text-blue-500"
                : newPassword && !/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)
                ? "text-red-500"
                : "text-gray-500"
            }`}
          >
            {newPassword && /[!@#$%^&*(),.?":{}|<>]/.test(newPassword) ? (
              <svg
                className="text-blue-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            ) : newPassword && !/[!@#$%^&*(),.?":{}|<>]/.test(newPassword) ? (
              <svg
                className="text-red-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="8"
                viewBox="0 0 7 8"
                fill="none"
              >
                <path
                  d="M7 1.205L6.295 0.5L3.5 3.295L0.705 0.5L0 1.205L2.795 4L0 6.795L0.705 7.5L3.5 4.705L6.295 7.5L7 6.795L4.205 4L7 1.205Z"
                  fill="#EB1004"
                />
              </svg>
            ) : (
              <svg
                className="text-gray-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            )}
            At least one special character
          </li>
          <li
            className={`flex items-center ${
              newPassword && confirmPassword === newPassword
                ? "text-blue-500"
                : confirmPassword
                ? "text-red-500"
                : "text-gray-500"
            }`}
          >
            {newPassword && confirmPassword === newPassword ? (
              <svg
                className="text-blue-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            ) : confirmPassword ? (
              <svg
                className="text-red-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="8"
                viewBox="0 0 7 8"
                fill="currentColor"
              >
                <path
                  d="M7 1.205L6.295 0.5L3.5 3.295L0.705 0.5L0 1.205L2.795 4L0 6.795L0.705 7.5L3.5 4.705L6.295 7.5L7 6.795L4.205 4L7 1.205Z"
                  fill="#EB1004"
                />
              </svg>
            ) : (
              <svg
                className="text-gray-500 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M13.854 4.146a.5.5 0 0 0-.708 0L6.5 10.793 3.854 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7a.5.5 0 0 0 0-.708z" />
              </svg>
            )}
            Password must match
          </li>
        </ul>
      </div>
    </>
  );
};

export default CreatePassword;
